import './TimelineFilters.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DateRangePickerParams } from '@ui/DateRangePicker';
import { getTimelineSummarySelector } from '@timeline/@arch/selectors';
import React from 'react';
import { TimelineFilterSection } from './FilterSection';

import { ApplicationFilter, ApplicationFilterParams } from './ApplicationFilter';
import { ChangeRecordsFilter, ChangeRecordsFilterParams } from './ChangeRecordsFilter';
import { DisplayNameFilter, DisplayNameFilterParams } from './DisplayNameFilter';
import { FeatureFlag, TimelineChangeType } from '@sonar-software/sonar-core';
import { FollowingFilter, FollowingFilterParams } from './FollowingFilter';
import { ModifiedByFilter, ModifiedByFilterParams } from './ModifiedByFilter';
import { SystemChangesFilter, SystemChangesFilterParams } from './SystemChangesFilter';
import { TagFilter, TagFilterParams } from './TagFilter';
import { UpdateQueryParams, useSonarSelector } from '@hooks';

export type TimelineFiltersParams = ChangeRecordsFilterParams &
	DisplayNameFilterParams &
	SystemChangesFilterParams &
	DateRangePickerParams &
	ModifiedByFilterParams &
	FollowingFilterParams &
	TagFilterParams &
	ApplicationFilterParams;

interface TimelineFiltersProps {
	clearSelectedChangeType: () => void;
	highlightedChangeType?: TimelineChangeType;
	onChange: UpdateQueryParams<TimelineFiltersParams>;
	params: TimelineFiltersParams;
	selectedChangeType?: TimelineChangeType;
}

export const TimelineFilters: React.FC<TimelineFiltersProps> = ({
	clearSelectedChangeType,
	highlightedChangeType,
	onChange,
	params,
	selectedChangeType
}) => {
	const summary = useSonarSelector(getTimelineSummarySelector.data);
	const disabled = !Object.keys(summary?.changeCounts ?? {}).length;

	return (
		<div className='timeline-filters'>
			<TimelineFilterSection title={ COPY_SPECIFIC.DISPLAY_NAME }>
				<DisplayNameFilter
					disabled={ disabled }
					onChange={ onChange }
					value={ params.objectNameFilter } />
			</TimelineFilterSection>
			<TimelineFilterSection title={ COPY_SPECIFIC.MODIFIED_BY }>
				<ModifiedByFilter
					disabled={ disabled }
					onChange={ onChange }
					value={ params.modifiedByUsernames } />
			</TimelineFilterSection>
			<TimelineFilterSection title={ COPY_SPECIFIC.TAG }>
				<TagFilter
					disabled={ disabled }
					onChange={ onChange }
					value={ params.tagIds } />
			</TimelineFilterSection>
			<TimelineFilterSection
				featureFlag={ FeatureFlag.DataSecurityDashboard }
				title={ COPY_SPECIFIC.MONITORED_APPLICATIONS }>
				<ApplicationFilter
					disabled={ disabled }
					onChange={ onChange }
					value={ params.applicationIds } />
			</TimelineFilterSection>
			<TimelineFilterSection
				featureFlag={ FeatureFlag.Followers }
				title={ COPY_SPECIFIC.FOLLOWING }>
				<FollowingFilter
					disabled={ disabled }
					onChange={ onChange }
					value={ params.isFollowing } />
			</TimelineFilterSection>
			<TimelineFilterSection>
				<SystemChangesFilter
					checked={ !params.system }
					disabled={ disabled }
					onChange={ onChange } />
			</TimelineFilterSection>
			<TimelineFilterSection>
				<ChangeRecordsFilter
					clearSelectedChangeType={ clearSelectedChangeType }
					highlightedChangeType={ highlightedChangeType }
					onChange={ onChange }
					params={ params }
					selectedChangeType={ selectedChangeType } />
			</TimelineFilterSection>
		</div>
	);
};
